export enum ORDER_TYPE_CODE {
    Vendi = 'VENDI',
    Promo = 'PROMO',
}
